import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalMessageService, RoutingService, TranslationService, GlobalMessageType, I18nModule } from '@spartacus/core';
import { CustomFormValidators, FormErrorsComponent } from '@spartacus/storefront';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import InventoryManagementService from '../../custom-landing/inventory-unpublished-batch/inventory-management.service';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf } from '@angular/common';
import { PasswordStrengthMeterComponent } from '../../../shared/password-strength-meter/password-strength-meter.component';

@Component({
    selector: 'app-custom-reset-password',
    templateUrl: './custom-reset-password.component.html',
    styleUrls: ['./custom-reset-password.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, FormsModule, ReactiveFormsModule, NgIf, FormErrorsComponent, PasswordStrengthMeterComponent, I18nModule]
})
export class CustomResetPasswordComponent implements OnInit {
  resetForm: UntypedFormGroup;
  title: any;
  navigationData: string;
  token: any;
  privacyPolicyStr: any;
  termsOfUseStr: any;
  @Output()
  submitted = new EventEmitter<{ oldPassword: string; newPassword: string }>();

  @Output()
  cancelled = new EventEmitter<void>();
  showError = false;
  error: string;
  termsOfUsePartner: any;
  chinaInstance:any;

  constructor(
    private translation: TranslationService,
    private fb: UntypedFormBuilder,
    private routingService: RoutingService,
    private route: ActivatedRoute,
    private customProductService: CustomProductsService,
    private customProfileService: CustomProfileService,
    private toastService: ToastService,
    protected  globalMessageService: GlobalMessageService,
    private inventoryManagementService: InventoryManagementService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getFooterData();
    this.customProductService.getHomeLinkActive(false);
    this.token = this.route.snapshot.queryParamMap.get('pwrt');
    console.log(this.token);
    this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
      this.error = res;
    });
    this.translation.translate('breadcrumb.resetPassword.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.resetPassword.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });

    this.resetForm = this.fb.group(
      {
        // oldPassword: [null, [Validators.required]],
        newPassword: ['', [Validators.required, Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%*]).{8}/)]],
        newPasswordConfirm: ['', [Validators.required]],
      },
      {
        validators: CustomFormValidators.passwordsMustMatch(
          'newPassword',
          'newPasswordConfirm'
        ),
      }
    );
  }

  validatePass(c: UntypedFormControl): any{
    const EMAIL_REGEXP = /(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%*]).{8}/;

    return EMAIL_REGEXP.test(c.value) ? null : {
      validatePass: {
        valid: false
      }
    };
  }

  onSubmit(): void {
    if (this.resetForm.valid) {
      this.submitted.emit({
        oldPassword: this.resetForm.value.oldPassword,
        newPassword: this.resetForm.value.newPassword,
      });
    } else {
      this.resetForm.markAllAsTouched();
    }
    this.resetPassword();
  }
  // tslint:disable-next-line:typedef
  onStrengthChange(strength) {
  }
  resetPassword(): any {
    const { newPassword } = this.resetForm.controls;
    this.customProfileService.resetPassword(this.token, newPassword.value).subscribe(
      data => {

        if (data.success || data.error){
          if (data.success){
            this.toastService.show(data.success);
            this.routingService.go({
              cxRoute: 'login',
            });
          }else if (data.error){
           // this.showError = true;
            this.globalMessageService.add(data.error, GlobalMessageType.MSG_TYPE_ERROR);
          }
        }else{
          if (data === 'success'){
            this.toastService.show('Password Reset Successful !!!');
            this.routingService.go({
              cxRoute: 'login',
            });
          }else {
            this.toastService.show(this.error);
          }
        }

      }
    );
  }
  onCancel(): void {
    this.routingService.go({
      cxRoute: 'login',
    });
  }
  getFooterData() {
    this.inventoryManagementService.getHelpData().subscribe((resp: any)=>{
  
    // if(resp.chinaInstanceCheck == 'true'){
      this.privacyPolicyStr = resp.privacyPolicy;
      this.termsOfUseStr = resp.termsOfUse;
      this.termsOfUsePartner = resp.termsOfUsePartner?resp.termsOfUsePartner:"";
      this.chinaInstance= resp.chinaInstanceCheck;

    // }else{
      // this.privacyPolicyStr = 'https://www.bhp.com/privacy-policy';
      // this.termsOfUseStr = 'https://www.bhp.com/terms-of-use';
    // }

    this.cd.detectChanges();
  });
}
}
